import { render, staticRenderFns } from "./SetDiscountDialog.vue?vue&type=template&id=71e63fa4"
import script from "./SetDiscountDialog.vue?vue&type=script&lang=js"
export * from "./SetDiscountDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports